import { useQuery } from '@tanstack/react-query';

import { GroupService } from './groupService';
import { GroupKey } from './keys';

export function useGetGroups() {
  return useQuery({
    queryKey: [GroupKey.GROUPS],
    queryFn: () => GroupService.getGroups().then((response) => response.data),
  });
}
